import React from "react";

import { motion } from "framer-motion/dist/framer-motion";

import DataFieldsModal from "./DataFields/DataFieldsModal";
import DataFieldsButton from "./DataFieldsButton";

export default function CoaDataFieldsPanel({
  showDataFieldsModal,
  toggleDataFieldsModal,
  showButton = true,
}) {
  return (
    <>
      {showButton && (
        <DataFieldsButton
          toggleDataFieldsModal={toggleDataFieldsModal}
          showDataFieldsModal={showDataFieldsModal}
        />
      )}
      {showDataFieldsModal && (
        <>
          <button
            type="button"
            className="dataFieldsModal__Backdrop"
            aria-label="Close data fields panel"
            onClick={toggleDataFieldsModal}
          />
          <motion.div
            className="dataFieldsModalContainer"
            initial={{ x: 40, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.25, ease: "easeOut" }}
          >
            <DataFieldsModal
              dataFieldCategory="data_fields"
              onClose={toggleDataFieldsModal}
            />
          </motion.div>
        </>
      )}
    </>
  );
}
